var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "eid-preview-wrap" },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.spinning } },
        [
          _c("pageTitle"),
          _c(
            "div",
            { staticClass: "page-main" },
            [
              _c(
                "a-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c("div", { staticClass: "video-title" }, [
                        _c("p", { staticClass: "title" }, [_vm._v("名称 :")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.title,
                              expression: "title",
                            },
                          ],
                          staticClass: "bb1 question_detail_page_help",
                          staticStyle: { width: "373px" },
                          attrs: { readonly: "", placeholder: "请输入名称" },
                          domProps: { value: _vm.title },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.title = $event.target.value
                            },
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "video-title" }, [
                        _c("p", { staticClass: "title" }, [_vm._v("视频 :")]),
                        !_vm.spinning
                          ? _c(
                              "div",
                              [
                                _c("video-player", {
                                  ref: "videoPlayer",
                                  staticClass: "video-player vjs-custom-skin",
                                  attrs: {
                                    playsinline: true,
                                    options: _vm.playerOptions,
                                  },
                                }),
                                _c("br"),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _c("a-table", {
                        attrs: {
                          columns: _vm.columns,
                          total: _vm.pagination.total,
                          pagination: _vm.pagination,
                          loading: _vm.loading,
                          rowKey: "commentId",
                          dataSource: _vm.dataSource,
                        },
                        on: { change: _vm.handleTableChange },
                        scopedSlots: _vm._u([
                          {
                            key: "avatar",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "viewer",
                                  { attrs: { images: [record.avatar] } },
                                  [
                                    _c("a-avatar", {
                                      attrs: {
                                        src: record.avatar,
                                        size: "large",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "showStatus",
                            fn: function (text, record) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      Boolean(record.showStatus)
                                        ? "正常"
                                        : "已屏蔽"
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "action",
                            fn: function (text, record, index) {
                              return [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "link" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.statusChange(record, index)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          Boolean(record.showStatus)
                                            ? "屏蔽"
                                            : "恢复"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { span: 12 } }, [
                    _c("div", {}, [
                      _c(
                        "p",
                        {
                          staticClass: "title mt25",
                          staticStyle: { display: "block" },
                        },
                        [_vm._v("教程详情:")]
                      ),
                      _c("div", { staticClass: "eid-preview" }, [
                        _c("div", { staticClass: "preview" }, [
                          _c("div", { staticClass: "preview-header" }),
                          _c("div", {
                            staticClass: "content-html",
                            domProps: { innerHTML: _vm._s(_vm.content) },
                          }),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }